// import Vue from 'vue'
// window.Vue = require('vue');
// import moment from 'moment';
import "bootstrap";
import VueRouter from "vue-router";
import App from "./views/App";
import MobileApp from "./views/user/mobile/App";
import {
    routes
} from "./router";
import {
    Form,
    HasError,
    AlertError
} from "vform";
import Vuex from "vuex";
import store from "./store/Store";
import NProgress from "nprogress";
import "../../node_modules/nprogress/nprogress.css";
import VueClipboard from "vue-clipboard2";
import MyDataTable from "./components/DataTable";
import AddModal from "./components/AddModal";
import VueProgressBar from "vue-progressbar";
import swal from "sweetalert2";
import vueCountryRegionSelect from "vue-country-region-select";
import BootstrapVue from "bootstrap-vue";
import Register from "./views/auth/Register";
import VueFormWizard from "vue-form-wizard";

// import 'vue-form-wizard/dist/vue-form-wizard.min.css'

Vue.use(BootstrapVue);

Vue.use(vueCountryRegionSelect);
Vue.use(VueFormWizard);

window.swal = swal;
const toast = swal.mixin({
    toast: true,
    position: "bottom-right",
    showConfirmButton: false,
    timer: 3000
});
window.toast = toast;

Vue.component("pagination", require("laravel-vue-pagination"));
Vue.use(VueClipboard);
Vue.use(Vuex);
Vue.use(VueProgressBar, {
    color: "rgb(143, 255, 199)",
    failedColor: "red",
    height: "3px"
});
Vue.component("Register", Register);
Vue.component("mobiledashboard", MobileApp);
Vue.component("add-modal", AddModal);
Vue.component("my-data-table", MyDataTable);
Vue.component(HasError.name, HasError);
Vue.component(AlertError.name, AlertError);

window.Form = Form;
window.Fire = new Vue();

const router = new VueRouter({
    mode: "history",
    routes
});

router.beforeResolve((to, from, next) => {
    if (to.name) {
        NProgress.start();
    }
    next();
});

router.afterEach((to, from) => {
    NProgress.done();
});

const app = new Vue({
    el: "#app",
    components: {
        App,
    },
    router,
    store,
    Fire
});
